module.exports = __webpack_public_path__ + "assets/media/skip-back.3221a769.svg";